import React, { ChangeEvent, KeyboardEventHandler, useEffect, useState } from "react";
import { isPostcodeValid } from "@glamcorner/core-cf-lib/lib/common/validators/postcode";
import { Input } from "@glamcorner/components/lib/core/components/Input";

interface PostcodeProps {
  errorMessage?: string | undefined;
  isRequiredField?: boolean;
  onBlur?: (newValue: string) => void;
  onChange: (newValue: string) => void | Promise<void>;
  onEnterKey?: (newValue: string) => void;
  value?: string;
  withMessageSpacing?: boolean;
}

export const Postcode: React.FC<PostcodeProps> = ({
  errorMessage,
  isRequiredField = false,
  onBlur,
  onChange,
  onEnterKey,
  withMessageSpacing,
  value = "",
}) => {
  const [postcode, setPostcode] = useState(value);
  const [valid, setValid] = useState(true);

  useEffect(() => {
    setPostcode(value);
  }, [value]);

  const onInputChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value.trim();
    setPostcode(newValue);

    if (newValue.length > 3) {
      const isValid = isPostcodeValid(newValue);
      setValid(isValid);

      if (isValid) {
        onChange(newValue);
      }
    }
  };

  const onInputBlurHandler = () => {
    const isValid = isPostcodeValid(postcode);
    setValid(isValid);

    if (isValid && onBlur) {
      onBlur(postcode.trim());
    }
  };

  const onKeyDownHandler: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === "Enter") {
      const isValid = isPostcodeValid(postcode);
      setValid(isValid);

      if (isValid && onEnterKey) {
        onEnterKey(postcode.trim());
      }
    }
  };

  let validationError = errorMessage;

  if (!valid) {
    if (postcode.trim().length > 0) {
      validationError = "Invalid";
    } else if (isRequiredField) {
      validationError = "Required";
    }
  }

  return (
    <Input
      wrapperClass="c-postcode"
      errorMessage={validationError}
      withMessageSpacing={withMessageSpacing}
      name="postcode"
      aria-label="postcode"
      maxLength={4}
      onChange={onInputChangeHandler}
      onBlur={onInputBlurHandler}
      onFocus={(event) => event.target.select()}
      onKeyDown={onKeyDownHandler}
      data-error={!!validationError}
      type="tel"
      value={postcode}
    />
  );
};
